<template>
  <div class="full-height theme-bg-gray q-pa-lg text-center waiting">
    <div class="text-weight-bolder font-size-16 q-px-xl">
      <span>{{ $t('waiting.ovoMsg') }}</span>
    </div>
    <div class="countDown q-mt-sm">
      <span class="num">
        {{ timerNum &lt; 10 ? `0${timerNum}` : timerNum }}
      </span>
      <span class="unit">s</span>
    </div>
    <div>
      <PayStepTip type="OVO" />
    </div>
    <!-- <MButton :loading="checking" style="margin: 30px 10px 0" @click="debounceCheck(true)">
      {{ $t('waiting.qrisCheckStatusText') }}
    </MButton> -->
    <BaseLogo />
  </div>
</template>

<script>
import {
  getOrderInfo,
  reversalCheck,
  checkReversalStatus,
  reOrder,
  checkoutStatus,
  pullPaymentStatus,
} from 'src/api/order.js';
import {
  closeDialogMixin,
  Error,
  Loading,
  Timeout,
  dialogQueue,
} from 'src/components/dialog/index';
import MButton from 'src/components/MButton/index.vue';
import { debounce } from 'quasar';
import { PAY_STATUS, showPayFailedDialog } from '../config';
import { createMeta } from './meta';
import { showDialog } from '../../../utils/error_config';
import PayStepTip from '../components/PayStepTip.vue';

export default {
  components: {
    // MButton,
    PayStepTip
},
  mixins: [closeDialogMixin],
  meta() {
    return createMeta(this);
  },
  inject: ['reload'],
  data() {
    return {
      timeClock: null,
      timerNum: 0,
      timer: true,
      dialog: null,
      debounceCheck: null,
      checking: false
    };
  },
  created() {
    const currentId = this.$router.currentRoute.query.orderId;
    this.$store.dispatch('Menu/setOrderId', currentId.replace(/\d+_DM/, ''));
  },
  mounted() {
    this.apiGetOrderInfo();
    this.debounceCheck = debounce(this.apiGetOrderInfo, 400);
  },
  beforeDestroy() {
    this.endCountdown();
  },
  destroyed() {
    window.removeEventListener(
      'popstate',
      window.history.pushState(null, null, document.URL),
      false,
    );
  },
  methods: {
    // 请求订单状态
    apiGetOrderInfo(munual) {
      const payPrefId = this.detail?.payments?.[0]?.orderPaymentPreferenceId;
      const orderId = payPrefId
        ? `${payPrefId}_DM${this.orderId}`
        : this.orderId;
      const fn = munual ? pullPaymentStatus : checkoutStatus;
      if (munual) this.checking = true;
      fn({ orderId })
        .then((res) => {
          if (!res.success) return showDialog(this, res.code);
          const { paymentStatus, orderDetail, paymentFailureReason } =
            res?.data ?? {};
          this.detail = orderDetail;
          // 订单支付成功
          if (paymentStatus === 'SUCCESS') {
            this.paySuccess(orderDetail);
            return;
          }

          // 订单支付失败
          if (paymentStatus === 'FAILED') {
            this.payFailure(orderDetail, paymentFailureReason);
            return;
          }

          // 订单等待 开启倒计时
          if (this.timeClock === null) {
            this.timerNum = res.data.expiredDate || 0;
            this.startCountdown();
          }

          if (paymentStatus === PAY_STATUS.PENDING && munual) {
            showPayFailedDialog(this, PAY_STATUS.PENDING);
          }
        })
        .finally(() => {
          if (munual) this.checking = false;
          // 重新请求
          if (this.timer) {
            setTimeout(() => {
              if (!munual) this.apiGetOrderInfo();
            }, 3000);
          }
        });
    },
    // 支付成功
    paySuccess(detail) {
      this.endWait();
      this.endCountdown();
      const url = this.$route.params.store;
      if (detail?.serviceType === 'FULL_DINE_IN') {
        this.$router.push({
          name: 'FullPaySuccess',
          query: {
            orderId: detail.orderId,
          },
        });
      } else {
        this.$router.push({
          path: `/${url}/result/success`,
          query: {
            orderId: detail.orderId,
          },
        });
      }
    },

    // 支付失败
    payFailure(details, reason) {
      this.endCountdown();
      const { payments } = details;
      if (payments[0].paymentMethodTypeId === 'OVO') {
        if (!reason) return;
        switch (reason) {
          // 失败原因: 需要反转(退款)
          case 'NEED_REVERSAL':
            this.goReversalCheck(details);
            break;
          // 失败原因: 支付被拒绝
          case 'DECLINED_BY_USER':
            this.endWait();
            dialogQueue.push(
              this.$q
                .dialog({
                  component: Error,
                  parent: this,
                  title: this.$t('waiting.paymentRejectedTitle_new'),
                  okText: this.$t('waiting.okBtn'),
                  showCancel: true,
                  cancelText: this.$t('waiting.cancelbtn'),
                })
                .onOk(() => {
                  this.onReOrder(details.orderId, details);
                }),
            );
            break;
          // 失败原因: 支付超时
          case 'PAYMENT_TIMEOUT':
            this.endWait();
            dialogQueue.push(
              this.$q
                .dialog({
                  component: Timeout,
                  parent: this,
                  title: this.$t('waiting.paymentTimeOutTitle'),
                  okText: this.$t('waiting.okBtn'),
                  cancel: true,
                  showCancel: true,
                  cancelText: this.$t('waiting.cancelbtn'),
                })
                .onOk(() => {
                  this.onReOrder(details.orderId, details);
                }),
            );
            break;
          // 失败原因: 无法推送通知到第三方APP
          case 'FAILED_RECEIVE_NOTIFY':
            this.endWait();
            dialogQueue.push(
              this.$q
                .dialog({
                  component: Error,
                  parent: this,
                  title: this.$t('waiting.paymentFailureTitle'),
                  okText: this.$t('waiting.okBtn'),
                })
                .onOk(() => {
                  this.onReOrder(details.orderId, details);
                }),
            );
            break;
          // 其他失败原因：
          // reason === 'INVALID_AMOUNT' // 不满足最低交易金额
          // reason === 'INVALID_ACCOUNT' // 支付账号不合法
          // reason === 'CANCELLED_BY_STORE' // 订单被店铺取消
          // reason === 'THIRD_PARTY_ERROR' // 第三方支付机构系统报错
          default:
            dialogQueue.push(
              this.$q
                .dialog({
                  component: Error,
                  parent: this,
                  title: this.$t('waiting.paymentRejectedTitle'),
                  okText: this.$t('waiting.okBtn'),
                  showCancel: true,
                  cancelText: this.$t('waiting.cancelbtn'),
                })
                .onOk(() => {
                  this.onReOrder(details.orderId, details);
                }),
            );
        }
      } else {
        this.endWait();
        dialogQueue.push(
          this.$q
            .dialog({
              component: Error,
              parent: this,
              title: this.$t('componentsBaseDialog.payErrorMsg2'),
              okText: this.$t('waiting.okBtn'),
              showCancel: true,
              cancelText: this.$t('waiting.cancelbtn'),
            })
            .onOk(() => {
              this.onReOrder(details.orderId, details);
            }),
        );
      }
      this.timer = false;
      this.timerNum = 0;
    },
    // 反转支付(退款)
    goReversalCheck(details) {
      const params = {
        orderId: details.orderId,
      };
      reversalCheck(params).then((res) => {
        if (res?.code === 200 && res?.data === 'PENDING') {
          this.apiCheckReversalStatus(details);
        }
      });
    },
    // 查询反转状态
    apiCheckReversalStatus(details) {
      const { payments } = details;
      const params = {
        orderId: details.orderId,
      };
      checkReversalStatus(params).then((res = {}) => {
        const { code, data } = res;
        // 反转成功
        if (code === 200 && data === 'SUCCESS') {
          this.endWait();
          dialogQueue.push(
            this.$q
              .dialog({
                component: Error,
                parent: this,
                title: this.$t('waiting.reversalSuccessTitle'),
                describe: this.$t('waiting.reversalSuccessDesc'),
                showOrderId: true,
                orderAmount: payments[0].amount,
                okText: this.$t('waiting.okBtn'),
                showCancel: true,
                cancelText: this.$t('waiting.cancelbtn'),
              })
              .onOk(() => {
                this.onReOrder(details.orderId, details);
              }),
          );
        }
        // 反转失败
        if (code === 200 && data === 'FAILED') {
          this.endWait();
          if (
            details.serviceType === 'PICK_UP' ||
            details.serviceType === 'DINE_IN'
          ) {
            dialogQueue.push(
              this.$q
                .dialog({
                  component: Error,
                  parent: this,
                  title: this.$t('waiting.reversalFailureDineOrPickTitle'),
                  describe: this.$t('waiting.reversalFailureDineOrPickDesc'),
                  showOrderId: true,
                  orderAmount: payments[0].amount,
                  okText: this.$t('waiting.okBtn'),
                  showCancel: true,
                  cancelText: this.$t('waiting.cancelbtn'),
                })
                .onOk(() => {
                  this.onReOrder(details.orderId, details);
                }),
            );
          } else {
            dialogQueue.push(
              this.$q
                .dialog({
                  component: Error,
                  parent: this,
                  title: this.$t('waiting.reversalFailureDeliveryTitle'),
                  describe: this.$t('waiting.reversalFailureDeliveryDesc'),
                  showOrderId: true,
                  orderAmount: payments[0].amount,
                  okText: this.$t('waiting.okBtn'),
                  showCancel: true,
                  cancelText: this.$t('waiting.cancelbtn'),
                })
                .onOk(() => {
                  this.onReOrder(details.orderId, details);
                }),
            );
          }
        }

        if (code === 200 && data === 'PENDING') {
          setTimeout(() => {
            this.apiCheckReversalStatus(details);
          }, 3000);
        }
      });
    },
    // 复原购物车
    onReOrder(orderId, details) {
      if (details?.serviceType === 'FULL_DINE_IN') {
        this.$router.replace({
          name: 'FullCheckout',
          query: { orderId },
        });
        return;
      }
      reOrder({ orderId }).then(() => {
        // 服务端数据有延迟，所以延迟一秒处理
        setTimeout(() => {
          this.$router.push({ name: 'checkout' });
        }, 1000);
      });
    },

    // 倒计时
    startCountdown() {
      this.timeClock = setInterval(() => {
        this.timerNum -= 1;
        if (this.timerNum < 0) {
          this.timerNum = 0;
          // 倒计时结束 弹出等待窗口
          this.dialog = this.$q.dialog({
            component: Loading,
            parent: this,
            title: this.$t('waiting.countdownTitle'),
            describe: this.$t('waiting.countdownDesc'),
          });
          clearInterval(this.timeClock);
          this.timeClock = null;
        }
        dialogQueue.push(this.dialog);
      }, 1000);
    },
    // 关闭等待窗口
    endWait() {
      if (this.dialog) {
        this.dialog.hide();
        this.dialog = null;
      }
    },
    // 停止计时器
    endCountdown() {
      this.timer = false;
      if (this.timeClock) {
        clearInterval(this.timeClock);
        this.timeClock = null;
        this.timerNum = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.waiting {
  display: flex;
  flex-direction: column;
  padding-top: 72px;
  position: relative;
  min-height: 300px;

  .countDown {
    color: #ff9e2d;
    margin-top: 10px;
    margin-bottom: 20px;

    .num {
      font-weight: bold;
      font-size: 36px;
      line-height: 40px;
    }

    .unit {
      font-size: 16px;
      line-height: 24px;
      vertical-align: super;
      margin-left: 4px;
    }
  }
}
</style>
